import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiResponse } from 'src/app/domain/interfaces/application/api-response.interface'
import { AccountType } from 'src/app/domain/models/erp/company/account-type.model'
import { BankAccount } from 'src/app/domain/models/erp/registration/bank-account.model'
import { FinancialInstitution } from 'src/app/domain/models/erp/shared/financial-institution.model'
import { environment } from 'src/environments/environment'

const PYANALITICS_URL = environment.pyAnaliticsURL
const BOREAL_URL = environment.borealURL

@Injectable({ providedIn: 'root' })
export class RegistrationBankAccountRepositoryService {
  private httpClient: HttpClient = inject(HttpClient)

  public getBankAccountList(): Observable<HttpResponse<ApiResponse<Array<BankAccount>>>> {
    return this.httpClient.get(`${BOREAL_URL}/registration/company-account`, { observe: 'response' })
  }

  public updateBankAccount(payload: FormData): Observable<HttpResponse<any>> {
    return this.httpClient.put(`${BOREAL_URL}/registration/company-account`, payload, { observe: 'response' })
  }

  public inactiveBankAccount(accountId: number): Observable<HttpResponse<any>> {
    return this.httpClient.patch(`${BOREAL_URL}/registration/company-account/${accountId}/inactive`, {}, { observe: 'response' })
  }

  public activeBankAccount(accountId: number): Observable<HttpResponse<any>> {
    return this.httpClient.patch(`${BOREAL_URL}/registration/company-account/${accountId}/active`, {}, { observe: 'response' })
  }

  public getAccountsType(): Observable<HttpResponse<ApiResponse<Array<AccountType>>>> {
    return this.httpClient.get(`${BOREAL_URL}/registration/company-account/account-types`, { observe: 'response' })
  }

  public getFinancialInstitution(): Observable<HttpResponse<ApiResponse<Array<FinancialInstitution>>>> {
    return this.httpClient.get(`${BOREAL_URL}/registration/company-account/financial-institutions`, { observe: 'response' })
  }

  public getCompanyAccountOptions(showInactives: boolean = false, includeAccountPlan: boolean = false, accountTypeIds: Array<number> = []): Observable<HttpResponse<ApiResponse<{ companyAccountList: Array<any> }>>> {
    let params = new HttpParams().set('showInactives', String(showInactives))
    if (includeAccountPlan) params = params.set('includeAccountPlan', 'true')
    accountTypeIds.forEach((accountTypeId: number) => (params = params.append('accountTypeIds', String(accountTypeId))))
    return this.httpClient.get(`${BOREAL_URL}/registration/company-account/get-all`, { observe: 'response', params })
  }

  public getCompanyAccountOptionsByCompanies(payload: { companyIds: Array<number>; showInactives?: boolean }): Observable<HttpResponse<ApiResponse<{ companyAccountList: Array<any> }>>> {
    return this.httpClient.post(`${BOREAL_URL}/registration/company-account/by-companies`, payload, { observe: 'response' })
  }

  public createBankAccount(payload: FormData): Observable<HttpResponse<any>> {
    return this.httpClient.post(`${BOREAL_URL}/registration/company-account`, payload, { observe: 'response' })
  }

  public exportExcel(): Observable<HttpResponse<any>> {
    return this.httpClient.post(`${PYANALITICS_URL}/financeiro/exportar-contas-bancarias`, {}, { observe: 'response', responseType: 'blob' })
  }

  public getLogs(offset: number, limit: number): Observable<HttpResponse<any>> {
    const params = new HttpParams().set('offset', offset).set('limit', limit)
    return this.httpClient.get(`${BOREAL_URL}/registration/company-account/logs`, { observe: 'response', params })
  }

  public getTecnospeedHealthStatus(): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${BOREAL_URL}/registration/company-account/tecnospeed-health-status`, { observe: 'response' })
  }
}
